<template>
  <div class="multi">
    <div class="title">
      <h2 class="title-area" v-band-title tabindex="0">
        <span class="label">{{multiSectionTitle}}</span>
      </h2>
    </div>
    <div>
      <div class="launcher-band">
        <table>
          <caption>런처 밴드 테이블</caption>
          <tbody>
          <tr>
            <td v-for="(cell, index) in cellList" :key="'launcher_' + index">
              <a href="#" class="launcher-band-link" @click.prevent="goDetail(cell)">
                <div>
                  <img :src="cell.thumbnail" :alt="getTitle(cell) + ' 이미지'">
                  <span>{{getTitle(cell)}}</span>
                </div>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import { fetchFromEventObject, fetchOnContent } from '@/common/utils/request.common'
  import { CellEventMapper, getCellList } from '@/common/utils/gnb.fp'
  import { bandTitle } from '@/common/resources/directives'
  export default {
    name: 'TemplateLauncherBand',
    props: {
      sectionInfo: {
        type: Object
      }
    },
    directives: {
      bandTitle
    },
    data () {
      return {
        cellList: [],
        multiSectionTitle: '',
        isLoading: true,
        isVisible: false
      }
    },
    methods: {
      getTitle (cell) {
        return _.get(cell, 'title_list.0.text', '')
      },
      async setData () {
        if (this.cellList.length !== 0) return
        this.isLoading = true
        const response = await fetchOnContent(this.sectionInfo)
        this.cellList = getCellList(response)
        if (this.cellList.length === 0) { this.isVisible = false }
        this.isLoading = false
      },
      goDetail (cell) {
        const eventList = _.get(cell, 'event_list', [])
        const { onClick, onNavigation } = CellEventMapper(eventList)
        fetchFromEventObject(onClick)
        const navigationUrl = _.get(onNavigation, 'url', '')
          .replace('http://www.wavve.com', '')
          .replace('https://www.wavve.com', '')
        this.$router.push(navigationUrl)
      }
    },
    created () {
      this.setData()
      this.multiSectionTitle = _.get(this.sectionInfo, 'title', '')
    }
  }
</script>
<style scoped>
  .multi{
    width: 1240px;
    margin: 0 auto;
  }

  .multi .title{
    margin: 0 0 20px;
  }

  .multi .title h2{
    display: inline-block;
    font-size: 0;
    line-height: 36px;
    color: #fff;
    font-weight: 400;
    vertical-align: middle;
  }

  .title-area .label{
    display: inline-block;
    vertical-align: middle;
    color: #fff;
  }

  .title-area span{
    font-size: 24px;
    line-height: 36px;
  }

  /* 런처 밴드 */
  .launcher-band{
    margin-bottom: 80px;
  }

  .launcher-band table{
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  .launcher-band table td{
    padding: 0 5px;
  }

  .launcher-band table td:first-child{
    padding-left: 0;
  }

  .launcher-band table td:last-child{
    padding-right: 0;
  }

  .launcher-band-link{
    display: block;
    padding: 22px 0;
    background-color: #252525;
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }

  .launcher-band-link img{
    height: 36px;
  }

  .launcher-band-link img,
  .launcher-band-link span{
    vertical-align: middle;
  }

  .launcher-band-link img + span{
    display: inline-block;
    margin-left: 12px;
  }
</style>
